import React from 'react';

const Donate = () => {
    return (
        <div>
         <section class="project-single-area pt-120 pb-120">
            <div class="container">
               
                <div class="project-single__item">
                  <h3 class="fs-30 mb-30">DONATE NOW</h3>
                    
                    <h3 class="fs-30 mb-30">HELP! EMPOWER! EDUCATE!
                    </h3>
                    <p class="mb-20">The nation’s future depends on the youth, and the youth of marginalized society depends on you. As the building blocks of the country, they must be given fair and equal chances to prove themselves. They must have access to higher education and skill training hence craving the future that they truly deserve. </p>
                    <p class="">Joining hands is determined to create support to the youth of marginalized communities thereby transforming their lives. 
                    </p>
                    <p>
                    Just by a little support from you, we are able to instill the feelings of self-respect, resilience and self-worth in these youth that later transforms into giving something back to the society. 

                    </p>
                    <p>
                    Donations received by us are not just financial aid, they are the investment in the future of these youth. These aids create pathways to opportunities that would otherwise be difficult to achieve. 

                    </p>
                    <p>
                    Poverty, lack of resources and many social barriers keep many bright minds from achieving their full potential. Your donations help us create more confident, trained and a section of youth that believes in themselves. 

                    </p>
                    <p>
                        <b>
                    You can donate by:---- list the bank details and all here……</b>

                    </p>
                   
                </div>
            </div>
        </section>
        </div>
    );
};

export default Donate;